// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SXKe","col":"styles_col__RcGZn","actions":"styles_actions__2svqw","conflict":"styles_conflict__R-bFp"};